module.exports = __webpack_public_path__ + "img/video_1.a1bcb751.png";